import tataImg from '../Images/Tata.jpg';
import mamaImg from '../Images/Mama.jpg';
import daniel2Img from '../Images/Daniel2.jpg';

// Mock data for Masonry Homes LLC
// Helper to bulk-import and sort numerically (…1,2,3,…8)
function importAll(r) {
  return r
    .keys()
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
    .map(r);
}

const panamaWebps = importAll(
  require.context("../Images", false, /Panama[1-8]\.webp$/)
);

const panamaImages = panamaWebps; // use this if no separate cover

const GreenwoodWebps = importAll(
  require.context("../Images/2439 Greenwood", false, /[1-9]\.webp$/)
);

const GreenwoodImages = GreenwoodWebps; // use this if no separate cover

export const companyInfo = {
  name: "Masonry Homes LLC",
  tagline: "Building Dreams, Creating Foundations",
  phone: "(847) 242-1129",
  email: "contact@masonryhomesllc.com",
  address: "Subject to Change",
  founded: "2002",
  yearsExperience: "15+",
  completedProjects: "25+",
  satisfiedClients: "40+"
};

export const services = [
  {
    title: "Home Renovation",
    description: "Complete home makeovers from kitchen remodels to full house renovations.",
    icon: "Home"
  },
  {
    title: "New Construction", 
    description: "Custom residential homes built to your specifications and dreams.",
    icon: "Building"
  },
  {
    title: "Design Services",
    description: "Professional architectural and interior design consultation.",
    icon: "PenTool"
  },
  {
    title: "Additions & Extensions",
    description: "Seamless room additions, second-story builds, and bump-outs that match your home’s structure and finishes.",
    icon: "Maximize2"
  }
];



export const projects = [
  {
    id: 1,
    title: "Modern Family Residence",
    address: "2439 Greenwood Rd, Northbrook, IL 60062",
    description: "A stunning 4-bedroom modern home featuring premium finishes, and energy-efficient design.",
    images: panamaImages,
    category: "Renovation"
  },

  {
    id: 2,
    title: "Single Family Residence",
    address: "3819 N Panama Ave, Chicago, IL",
    description: "A refined 2-bedroom, 3-bath home in progress, gaining modern finishes, brighter interiors, and performance-minded updates.",
    images: GreenwoodImages,
    category: "Current"
  },
  
];

export const teamMembers = [
  {
    name: "Jaroslaw Moskal",
    title: "Founder & General Contractor",
    bio: "With over 15 years in construction, Jerry founded Masonry Homes to deliver quality craftsmanship and exceptional service.",
    image: tataImg,  
    imagePosition: "object-[50%_10%]"
  },
  {
    name: "Barbara Moskal",
    title: "Senior Accountant",
    bio: "Barbara safeguards our bottom line with meticulous job-costing, timely invoicing, and cash-flow foresight that keeps builds moving without surprises.",
    image: mamaImg,
    imagePosition: "object-center"
  },
  {
    name: "Daniel Moskal",
    title: "Project Manager/Designer",
    bio: "Daniel ensures every project runs smoothly, on time, and within budget while maintaining our high quality standards.",
    image: daniel2Img,  
    imagePosition: "object-[50%_20%]"
  }
];

export const testimonials = [
  {
    name: "Placeholder",
    text: "Placeholder",
    rating: 4,
    project: "Basement Renovation"
  },
  {
    name: "Placeholder",
    text: "Placeholder",
    rating: 4,
    project: "Custom Home Build"
  },
  {
    name: "Placeholder",
    text: "Placeholder",
    rating: 5,
    project: "Placeholder"
  }
];